import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GeneralSettings, Tool, ToolDeliverable } from 'app/profile/models/generic.model';
import { AuthData } from '@tesla/ng-auth';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { Store } from '@ngrx/store';
import { GetSupplierProfileCurrentUser } from 'app/profile/store/app.actions';
import { TslDialog, TslOption } from '@tesla/ng-tds';
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { GridReadyEvent } from 'ag-grid-community';

@Component({
    selector: 'app-reorder-deliverables-dialog',
    templateUrl: './reorder-deliverables-dialog.component.html',
    styleUrls: ['./reorder-deliverables-dialog.component.scss']
})
export class ReorderDeliverablesDialog implements OnInit {
    settings: GeneralSettings;
    showCMTChanges: any;
    deliverableForm: FormGroup;
    selectedEventDeliverables: ToolDeliverable[];
    allDeliverables: ToolDeliverable[];
    chosenEvent: number;
    displayedColumns: Array<string> = ['deliverable']


    get sortByType() { return this.deliverableForm.get('sortByType'); }
    get sortByManual() { return this.sortByType.value == 0; }
    get hasSelectedDeliverables() { return this.selectedEventDeliverables && this.selectedEventDeliverables.length > 0; }
    get hasAllDeliverables() { return this.allDeliverables && this.allDeliverables.length > 0; }

    constructor(private fb: FormBuilder,
        private authData: AuthData,
        private supplierStore: Store<SupplierState>,
        private dialog: TslDialog,
        public dialogRef: MatDialogRef<ReorderDeliverablesDialog>,
        @Inject(MAT_DIALOG_DATA) public data:
            {
                deliverablesList: ToolDeliverable[];
            }) {
            this.deliverableForm = this.fb.group({
                sortByType: [''],
                eventType: [''],
                columnType: [''],
            });
    }

    getSelectedDeliverableArray(event: TslOption){
        this.chosenEvent = event.value;
        this.selectedEventDeliverables = this.data.deliverablesList.filter( function(x){
            return x['eventType'] === event.value;
        });
    }

    sortByDate(event: TslOption){
        if(event.value == 0){
            this.allDeliverables = this.data.deliverablesList.sort(
                (objA, objB) => {
                    if(objA.eventType != objB.eventType){
                        return 0;
                    }
                    if(objA.startDate && objB.startDate){
                        return objA.startDate.valueOf() > objB.startDate.valueOf() ? 1 : -1;
                    }
                    else if(objA.deliverable && objB.startDate){
                        return 1;
                    }
                    else if(objB.deliverable && objA.startDate){
                        return -1;
                    }
                    return 0;
                });
        }
        else if(event.value == 1){
            this.allDeliverables = this.data.deliverablesList.sort(
                (objA, objB) => {
                    if(objA.eventType != objB.eventType){
                        return 0;
                    }
                    if(objA.plannedDate && objB.plannedDate){
                        return objA.plannedDate.valueOf() > objB.plannedDate.valueOf() ? 1 : -1;
                    }
                    else if(objA.deliverable && objB.plannedDate){
                        return 1;
                    }
                    else if(objB.deliverable && objA.plannedDate){
                        return -1;
                    }
                    return 0;
                });
        }
        else if(event.value == 2){
            this.allDeliverables = this.data.deliverablesList.sort(
                (objA, objB) => {
                    if(objA.eventType != objB.eventType){
                        return 0;
                    }
                    if(objA.actualDate && objB.actualDate){
                        return objA.actualDate.valueOf() > objB.actualDate.valueOf() ? 1 : -1;
                    }
                    else if(objA.deliverable && objB.actualDate){
                        return 1;
                    }
                    else if(objB.deliverable && objA.actualDate){
                        return -1;
                    }
                    return 0;
                });
        }
    }

    hasDeliverable( del:ToolDeliverable ){
        return del.deliverable && del.deliverable.length > 0;
    }

    ngOnInit() {
        const userInfo = this.authData.getUserInfo();
        this.supplierStore.dispatch(new GetSupplierProfileCurrentUser());
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSave(){
        this.dialog.confirm('Confirm Changes', "Are you sure you want to change the order?")
            .afterClosed()
            .subscribe(confirmed => {
                if(confirmed){
                    this.data.deliverablesList = this.allDeliverables;
                    this.dialogRef.close({ toolData: this.data.deliverablesList });
                }
            });
    }

    isDeliverableHeader(index, item): boolean {
        return item.isGroup;
    }

    onDrop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.selectedEventDeliverables, event.previousIndex, event.currentIndex);
        this.allDeliverables = this.data.deliverablesList;
        let j = 0;
        for(let i = 0; i < this.allDeliverables.length; i++){
            if(this.allDeliverables[i].eventType == this.selectedEventDeliverables[j].eventType){
                this.allDeliverables[i] = this.selectedEventDeliverables[j];
                j++
            }
        }
        console.log(this.allDeliverables);
    }
}
